module.exports = __webpack_public_path__ + "static/media/cb2.84cd010f.jpg";